import { render, staticRenderFns } from "./PlusProductionBase.vue?vue&type=template&id=7c57ab0b&scoped=true"
import script from "./PlusProductionBase.vue?vue&type=script&lang=ts"
export * from "./PlusProductionBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c57ab0b",
  null
  
)

export default component.exports